import React from 'react';

const GeminiIcon = ({ width = '80', height = '80', color = '#f1c40f' }) => (
  <svg width={width} height={height} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M25 20V80" stroke={color} strokeWidth="5" strokeLinecap="round"/>
    <path d="M75 20V80" stroke={color} strokeWidth="5" strokeLinecap="round"/>
    <path d="M35 20H65" stroke={color} strokeWidth="5" strokeLinecap="round"/>
    <path d="M35 80H65" stroke={color} strokeWidth="5" strokeLinecap="round"/>
  </svg>
);

export default GeminiIcon;
